'use client';

import React, { useState, useEffect } from 'react';
import QuoteForm from './QuoteForm';
import QuoteResult from './QuoteResult';
import ServiceAreaMap from './ServiceAreaMap';

const QuoteInteractive = () => {
  const [isHydrated, setIsHydrated] = useState(false);
  const [quoteGenerated, setQuoteGenerated] = useState(false);
  const [quoteData, setQuoteData] = useState<any>(null);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const handleQuoteGenerated = (quote: any) => {
    setQuoteData(quote);
    setQuoteGenerated(true);
    if (typeof window !== 'undefined') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleNewQuote = () => {
    setQuoteGenerated(false);
    setQuoteData(null);
    if (typeof window !== 'undefined') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  if (!isHydrated) {
    return (
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-4xl mx-auto">
          <div className="animate-pulse space-y-6">
            <div className="h-12 bg-muted rounded w-3/4"></div>
            <div className="h-96 bg-muted rounded"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-4xl mx-auto">
        {!quoteGenerated ? (
          <div className="space-y-8">
            <QuoteForm onQuoteGenerated={handleQuoteGenerated} />
            <ServiceAreaMap />
          </div>
        ) : (
          <QuoteResult quote={quoteData} onNewQuote={handleNewQuote} />
        )}
      </div>
    </div>
  );
};

export default QuoteInteractive;